export const SITE_TITLE = 'Ian J. Miller (me)';
